import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { httpsCallable } from 'firebase/functions';

import './styles/ShopDetails.css';
import { functions } from "../firebase/config";
import Loader from "./Loader";

const VendorDeals = () => {
  const [loading, setLoading] = useState(true);
  const [deals, setDeals] = useState([]);
  const navigate = useNavigate();
  const { state } = useLocation();
  const { productName, location, currentAddress, user, inputDealValue,productImage } = state || {};

  useEffect(() => {
    const fetchDeals = async () => {
      try {
        const lat = parseFloat(location.lat);
        const lon = parseFloat(location.lng);
        const vendorDocRef = httpsCallable(functions, "getvendorslist");

        const response = await vendorDocRef({
          userLat: lat,
          userLon: lon,
          product: productName,
          distance: 10    //Need to be change based on collection fields
        });

        const vendorDocResp = response?.data?.vendors;
        if (Array.isArray(vendorDocResp)) {
          const filteredDeals = vendorDocResp.map((vendor) => ({
            shopName: vendor.name,
            productName,
            productImage,
            price: vendor.productPrice,
            updated: vendor.lastPriceUpdated,
            distance: parseFloat(((vendor.distance) * 1.25).toFixed(2)),
            imageUrl: vendor.shopImage,
            address: vendor.shopAddress,
            units: vendor.units,
            contact: vendor.contact,
            alternateContact: vendor.alternateContact,
            vendorLat: location.lat,
            vendorLng: location.lng,
            user
          }));

          setDeals(filteredDeals);
        }
      } catch (error) {
        console.error("Error fetching deals:", error);
      } finally {
        setLoading(false);
      }
    };

    if (productName && location) {
      fetchDeals();
    }
  }, [productName, location]);

  return (
    <div className="deal-results-container">
      {loading && <Loader />}

      <div className="user-header">
        <div className="profile">
          <img src={user.photoURL} alt="User" className="avatar" />
          <div className="user-info-text">
            <h4>{user.name}</h4>
            <p>{user.email}</p>
          </div>
          <div className="product-info">
             <img src={productImage} alt="product" className="avatar" />
             <p className="product-name">{productName}</p>
         </div>
        </div>
      </div>

      <div className="location-info">
        <span className="location-icon">📍</span>
        <span>{currentAddress}</span>
      </div>

      {/* <div className="banner">
        <h2>Hurray!</h2>
        <h3>Best deals for {productName}</h3>
      </div> */}

      <div className="deal-list">
        {deals.length === 0 ? (
          <p className="no-results">No vendors found within your area.</p>
        ) : (
          deals.map((deal, idx) => (
            <div key={idx} className="deal-card">
              <div className="deal-header">
                <h2 className="shop-name">{deal.shopName}</h2>
                <span className="price-badge">₹{deal.price} / {deal.units}</span>
              </div>

              <div className="deal-content">
                <span className="distance-badge">📍 {deal.distance} K.M approx</span>
                <p className="last-update">Price Last Updated on: {new Date(deal.updated).toLocaleDateString()}</p>

                {inputDealValue && (
                  <p className={`limited-offer ${parseFloat(inputDealValue) > deal.price ? 'save' : 'offer'}`}>
                    {parseFloat(inputDealValue) > deal.price
                      ? `🎉 Save ₹${(inputDealValue - parseFloat(deal.price)).toFixed(2)}`
                      : '🔥 Limited Time Offer!'}
                  </p>
                )}

                <button
                  className="get-details-btn"
                  onClick={() =>
                    navigate('/shopnavigationdetails', {
                      state: deal,
                      bannerImageUrl: deal.imageUrl
                    })
                  }
                >
                  Get Details
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default VendorDeals;
